import { useContext, useEffect } from "react";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";
import NotFound from "../../shared/assets/imgs/not_found.svg";
import Link from "../../components/Link/Link";
import { routes } from "../../shared/router/routes";
import { LayoutContext } from "../../shared/providers/layout/layout.provider";

function Page404() {
    const { translate } = useContext(TranslationContext);
    const { setIsLoading } = useContext(LoadingContext);
    const { setActions } = useContext(LayoutContext);

    useEffect(() => {
        setIsLoading(false);
    }, [setIsLoading]);

    useEffect(() => {

        setActions(<Link
            to={routes.HOME.path}
            icon="Chevron--left"
            iconSize={16}
            customCss="p-0 d-flex align-items-center gap-01 color-neutrals-black text-bd2-rg">
            {translate("common.back", "Back")}
        </Link>)

        return () => {
            setActions(undefined)
        }
    }, [translate]);

    return (
        <div className="px-12 px-md-31 pb-22 h-100 mt-4 pt-6">
            <div className="row h-100">
                <div className="col-md-6 offset-md-3 col-lg-4 col-12 offset-lg-4">
                    <div className="d-flex flex-column gap-02 align-items-center align-items-md-start">
                        <img src={NotFound} aria-hidden="true" alt="" width={225} />
                        <h1 className="text-h1-smbd mt-2">
                            {translate("page.404.title", "Page not found")}
                        </h1>
                        <p className="m-0 color-neutrals-dark text-bd1-rg">
                            {translate(
                                "page.404.description",
                                "The page you are looking for does not exist or may have been moved."
                            )}
                        </p>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Page404;
